import React, { useState, useEffect } from "react";
import socket from "./WebSocketService";

const Dashboard = () => {
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [finalImage, setFinalImage] = useState(null);
    const [stepsRestore, setStepsRestore] = useState(1);
    const [stepsQuality, setStepsQuality] = useState(1);
    const [stepsResolution, setStepsResolution] = useState(1);
    const [processing, setProcessing] = useState(""); // Process status
    const [isProcessing, setIsProcessing] = useState(false); // Controls submit button

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result);
                setImage(file);
                setFinalImage(null);
                setProcessing(""); // Reset progress on new upload
                setIsProcessing(false); // Allow resubmission
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = () => {
        if (!image) {
            alert("Please upload an image first!");
            return;
        }

        setIsProcessing(true); // Disable submit during processing

        const reader = new FileReader();
        reader.onload = () => {
            const base64Data = reader.result.split(",")[1]; // Extract Base64 part
            const fileExtension = image.name.split(".").pop(); // Get file extension

            const payload = {
                command: "submit",
                image: `data:image/${fileExtension};base64,${base64Data}`,
                restore: stepsRestore,
                quality: stepsQuality,
                resolution: stepsResolution,
            };

            socket.send(payload);
        };
        reader.readAsDataURL(image);
    };

    useEffect(() => {
        socket.onMessage((event) => {
            const response = event;

            if (response.command === "submit_response") {
                setProcessing(response.process || "Processing...");
                setPreview(response.data); // Update preview with received image

                if (response.is_end) {
                    setFinalImage(response.data);
                    setIsProcessing(false); // Enable submit button for a new process
                }
            }
        });
    }, []);

    return (
        <div>
            <h2>Image Processing</h2>

            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                {/* Input Fields */}
                <div>
                    <input type="file" accept="image/*" onChange={handleImageChange} />

                    <div>
                        <label>Steps for Restore:</label>
                        <input type="number" min="1" max="5" value={stepsRestore} onChange={(e) => setStepsRestore(Number(e.target.value))} />
                    </div>

                    <div>
                        <label>Steps for Image Quality:</label>
                        <input type="number" min="1" max="5" value={stepsQuality} onChange={(e) => setStepsQuality(Number(e.target.value))} />
                    </div>

                    <div>
                        <label>Steps for Resolution:</label>
                        <input type="number" min="1" max="5" value={stepsResolution} onChange={(e) => setStepsResolution(Number(e.target.value))} />
                    </div>

                    <button onClick={handleSubmit} disabled={isProcessing}>
                        {isProcessing ? "Processing..." : "Submit"}
                    </button>

                    {/* Show Processing Status */}
                    {processing && <p style={{ fontWeight: "bold" }}>{processing}</p>}
                </div>

                {/* Image Preview on the Right */}
                {preview && (
                    <div>
                        <h3>{finalImage ? "Final Processed Image" : "Processing Image"}</h3>
                        <img src={preview} alt="Processing Preview" style={{ width: "300px", border: "1px solid #ccc" }} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;
